import React from 'react';
import { FormViewContent } from 'components/FormViewContent';
import molecules from 'ctsutheme/components/molecules';
import atoms from 'ctsutheme/components/atoms';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { GetEmptyValue, NoDataFound } from 'components';


const { List, ListSubHeader } = molecules;
const { Typography, Divider } = atoms;

export const ViewPSRDetails = ({ data }) => {
  if (_.isEmpty(data)) {
    return <NoDataFound />;
  }

  const {
    comments,
    websiteDescription,
    websiteInstructions,
    ctsuGeneralInstructions,
    source,
    contactName,
    contactPhone,
    contactEmail,
    distributionEmail,
    createdBy,
    createdDate,
    modifiedBy,
    modifiedDate
  } = data || {};

  return (
    <>
      <List
        subheader={(
          <ListSubHeader flex>
            <Typography data-id="ctsuProcessInstructionsTitle" inline className="font-btn color-dark-blue font-bold">
            CTSU Processing Instructions
            </Typography>
          </ListSubHeader>
        )}
      >
        <FormViewContent
          primaryText="Source"
          name="source"
          secondaryText={<GetEmptyValue value={source} />}
        />
        <Divider />
        <FormViewContent
          primaryText="Website Description"
          name="websiteDescription"
          secondaryText={<GetEmptyValue value={websiteDescription} />}
        />
        <Divider />
        <FormViewContent
          primaryText="Website Instructions"
          secondaryText={<GetEmptyValue value={websiteInstructions} />}
        />
        <Divider />
        <FormViewContent
          more
          primaryText="CTSU Processing Instructions"
          name="ctsuGeneralInstructions"
          secondaryText={<GetEmptyValue value={ctsuGeneralInstructions} />}
        />
        <Divider />
        <FormViewContent
          primaryText="Comments"
          name="comments"
          secondaryText={<GetEmptyValue value={comments} />}
        />
      </List>
      <Divider />
      <List
        subheader={(
          <ListSubHeader flex>
            <Typography data-id="contactInfo" inline className="font-btn color-dark-blue font-bold">
              Contact Information
            </Typography>
          </ListSubHeader>
)}
      >
        <FormViewContent
          primaryText="Name"
          name="contactName"
          secondaryText={<GetEmptyValue value={contactName} />}
        />
        <Divider />
        <FormViewContent
          primaryText="Phone"
          secondaryText={<GetEmptyValue value={contactPhone} />}
        />
        <Divider />
        <FormViewContent
          primaryText="Email"
          name="contactEmail"
          secondaryText={<GetEmptyValue value={contactEmail} />}
        />
        <Divider />
        <FormViewContent
          primaryText="Distribution List"
          name="distributionEmail"
          secondaryText={<GetEmptyValue value={distributionEmail} />}
        />
      </List>
      <Divider />
      <List
        subheader={(
          <ListSubHeader flex>
            <Typography data-id="auditHistory" inline className="font-btn color-dark-blue font-bold">
            Audit History
            </Typography>
          </ListSubHeader>
    )}
      >
        <FormViewContent
          primaryText="Created By"
          name="createdBy"
          secondaryText={<GetEmptyValue value={createdBy} />}
        />
        <Divider />
        <FormViewContent
          primaryText="Created Date"
          name="createdDate"
          secondaryText={<GetEmptyValue value={createdDate} />}
        />
        <Divider />
        <FormViewContent
          primaryText="Modified By"
          secondaryText={<GetEmptyValue value={modifiedBy} />}
        />
        <Divider />
        <FormViewContent
          primaryText="Modified Date"
          name="modifiedDate"
          secondaryText={<GetEmptyValue value={modifiedDate} />}
        />
      </List>
    </>
  );
};

ViewPSRDetails.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object])
};

ViewPSRDetails.defaultProps = {
  data: null
};
